import { render, staticRenderFns } from "./ProjectSituation.vue?vue&type=template&id=252e8fd3&scoped=true&"
import script from "./ProjectSituation.vue?vue&type=script&lang=js&"
export * from "./ProjectSituation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252e8fd3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/webapp-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout,VTextarea})
